import React, { useEffect, useState, useMemo } from 'react';
import { Table, Container, Button, Form, Modal, Pagination, Spinner, FormControl, Col, Row } from 'react-bootstrap';
import { TruncateWords } from '../components/tool/tool';
import { Link } from 'react-router-dom';
import './style.css'; // Import the CSS file
import { connect } from "react-redux";
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {logout} from "../redux/reducers/user-actions";
import 'bootstrap-icons/font/bootstrap-icons.css';
function CreatorOrder({ user }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [songs, setSongs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalSongs, setTotalSongs] = useState(0);
  const [reload, setReload] = useState(0);
  const [songsPerPage] = useState(30);
  const [keyword, setKeyword] = useState('');
  const [searchword, setSearchword] = useState('');
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [resendingOrders, setResendingOrders] = useState(new Set());
  const [resendResults, setResendResults] = useState({});
  const [expandedOrders, setExpandedOrders] = useState(new Set());
  const [buyerInfo, setBuyerInfo] = useState(null);

  // The API returns a flat list of order items. Group them by order_id so the
  // table can show one row per order, expandable to reveal its songs.
  const orders = useMemo(() => {
    const map = new Map();
    for (const song of songs) {
      let order = map.get(song.order_id);
      if (!order) {
        order = {
          order_id: song.order_id,
          costumer_name: song.costumer_name,
          costumer_email: song.costumer_email,
          costumer_phone: song.costumer_phone,
          time: song.time,
          status: song.status,
          payment_method: song.payment_method,
          items: [],
          total_amount: 0,
        };
        map.set(song.order_id, order);
      }
      order.items.push(song);
      order.total_amount += song.amount || 0;
    }
    return Array.from(map.values());
  }, [songs]);

  const toggleExpand = (orderId) => {
    setExpandedOrders(prev => {
      const s = new Set(prev);
      s.has(orderId) ? s.delete(orderId) : s.add(orderId);
      return s;
    });
  };

  const statusText = (status) => {
    switch (status) {
      case "1": return "尚未付款";
      case "2": return "已付款";
      case "3": return "已出貨";
      case "4": return "已完成";
      case "5": return "已取消";
      default: return status;
    }
  };
  useEffect(() => {
    const controller = new AbortController();
    const fetchPages = async () => {
      const authToken = localStorage.getItem('authToken'); // Assuming the authToken is stored in localStorage
      let response;
      try {
        response = await fetch(process.env.REACT_APP_API_URL + `/api/creator/getorderlistcount?keyword=${encodeURIComponent(searchword)}`, {
          headers: {
            'Authorization': `${authToken}`
          },
          signal: controller.signal
        });
      } catch (e) {
        if (e.name !== 'AbortError') console.error(e);
        return
      }
      if (response.status === 401) {

        return
      }else if (!response.ok) {
        console.error('getorderlistcount failed:', response.status);
        return
      }else{
        const data = await response.json().catch(() => null);
        if (controller.signal.aborted) return;
        if (!data) return;
      setTotalSongs(data.num);
      setTotalPages(Math.ceil(data.num / songsPerPage));
      console.log(data.num);
      }
    };
    fetchPages();
    return () => controller.abort();
  }, [searchword]);
  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    console.log('Search button clicked');
    setSearchword(keyword);
  }
  useEffect(() => {
    const controller = new AbortController();
    const fetchSongs = async () => {
      setLoading(true);
      const authToken = localStorage.getItem('authToken'); // Assuming the authToken is stored in localStorage
      let response;
      try {
        response = await fetch(process.env.REACT_APP_API_URL + `/api/creator/getorderlist?page=${currentPage}&limit=${songsPerPage}&keyword=${encodeURIComponent(searchword)}`, {
          headers: {
            'Authorization': `${authToken}`
          },
          signal: controller.signal
        });
      } catch (e) {
        if (e.name === 'AbortError') return;
        console.error(e);
        window.alert('無法取得訂單資料，請稍後再試');
        setLoading(false);
        return
      }
      if (controller.signal.aborted) return;
      if (response.status === 401) {
        window.alert("請重新登入");
        dispatch(logout());
        navigate('/login');
        return
      }else if (!response.ok) {
        window.alert('無法取得訂單資料，請稍後再試');
        setLoading(false);
        return
      }else{
        const data = await response.json().catch(() => null);
        if (controller.signal.aborted) return;
        setSongs(Array.isArray(data) ? data : []);
        setLoading(false);
      }
    };
    fetchSongs();
    return () => controller.abort();
  }, [currentPage, searchword, reload]);
  const handlechange = (e) => {
    setKeyword(e.target.value);
  }
  const handleResendEmail = async (orderId) => {
    setResendingOrders(prev => new Set(prev).add(orderId));
    try {
      const authToken = localStorage.getItem('authToken');
      const response = await fetch(process.env.REACT_APP_API_URL + '/api/creator/resend-email', {
        method: 'POST',
        headers: {
          'Authorization': `${authToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ order_id: orderId }),
      });
      const data = await response.json();
      setResendResults(prev => ({ ...prev, [orderId]: { ok: response.ok, msg: response.ok ? '已重寄' : (data.error || '失敗') } }));
    } catch (e) {
      setResendResults(prev => ({ ...prev, [orderId]: { ok: false, msg: '失敗' } }));
    } finally {
      setResendingOrders(prev => { const s = new Set(prev); s.delete(orderId); return s; });
    }
  };

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <Container className={`my-3 ${loading ? 'loading-cursor' : ''}`} style={{ minHeight: '80vh' }}>
       <Button variant="outline-secondary" size="sm" onClick={() => {navigate('/dashboard')}}><i className="bi bi-arrow-return-left"></i>返回管理介面</Button>
      <h1 className="mt-2">顧客訂單紀錄</h1>
      <Form className="d-flex align-items-center" style={{ width: '100%' }}>
        <FormControl
            type="text"
            placeholder="歌名搜尋"
            onChange={handlechange}
            value={keyword}
            className="mr-sm-2"
            style={{ width: '20vw', marginRight: '2vw' }}
        />
        <Button variant="outline-success" type="submit" onClick={handleSearchSubmit}>搜尋</Button>
        {
          searchword !== '' ?
            <Button variant="outline-danger" type="submit" style={{ marginLeft: '2vw' }} onClick={() => { setSearchword(''); setKeyword('') }}>清除</Button>
            : ''
        }
      </Form>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
          <Spinner animation="border" role="status">
          </Spinner>
        </div>
      ) : (
        <>
          <Table striped bordered hover responsive className="mt-3">
            <thead>
              <tr>
                <th style={{ width: '40px' }}></th>
                <th>訂單編號</th>
                <th>買家</th>
                <th>歌曲數</th>
                <th>總金額</th>
                <th>時間</th>
                <th>狀態</th>
                <th>付款方式</th>
                <th>操作</th>
              </tr>
            </thead>
            {orders.length === 0 ? (
              <tbody>
                <tr>
                  <td colSpan="9" className="text-center">沒有訂單</td>
                </tr>
              </tbody>
            ) : (
            <tbody>
              {orders.map(order => {
                const isExpanded = expandedOrders.has(order.order_id);
                return (
                <React.Fragment key={order.order_id}>
                <tr
                  onClick={() => toggleExpand(order.order_id)}
                  style={{ cursor: 'pointer' }}
                >
                  <td className="text-center">
                    <Button
                      variant="link"
                      size="sm"
                      className="p-0 text-secondary"
                      aria-expanded={isExpanded}
                      aria-controls={`order-detail-${order.order_id}`}
                      aria-label={isExpanded ? '收合訂單明細' : '展開訂單明細'}
                      onClick={(e) => { e.stopPropagation(); toggleExpand(order.order_id); }}
                    >
                      <i className={`bi ${isExpanded ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                    </Button>
                  </td>
                  <td>{"TW" + order.order_id.toString().padStart(6, '0')}</td>
                  <td>
                    <Button
                      variant="link"
                      size="sm"
                      className="p-0 py-1 text-start buyer-link"
                      aria-haspopup="dialog"
                      aria-label={`檢視 ${order.costumer_name} 的買家資訊`}
                      onClick={(e) => { e.stopPropagation(); setBuyerInfo(order); }}
                      title="檢視買家資訊"
                    >
                      {order.costumer_name}
                    </Button>
                  </td>
                  <td>{order.items.length}</td>
                  <td>{order.total_amount}</td>
                  <td>{order.time}</td>
                  <td>{statusText(order.status)}</td>
                  <td>{order.payment_method}</td>
                  <td onClick={(e) => e.stopPropagation()}>
                    <div className="d-flex align-items-center gap-2">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        disabled={resendingOrders.has(order.order_id)}
                        onClick={() => handleResendEmail(order.order_id)}
                      >
                        {resendingOrders.has(order.order_id) ? <Spinner as="span" animation="border" size="sm" /> : '重寄Email'}
                      </Button>
                      {resendResults[order.order_id] && (
                        <span style={{ color: resendResults[order.order_id].ok ? '#16a34a' : '#dc2626', fontSize: '0.85rem' }}>
                          {resendResults[order.order_id].msg}
                        </span>
                      )}
                    </div>
                  </td>
                </tr>
                {isExpanded && (
                  <tr id={`order-detail-${order.order_id}`}>
                    <td colSpan="9" style={{ padding: '0.5rem 0.5rem 0.5rem 2.5rem', backgroundColor: '#fafafa', borderLeft: '3px solid #e4e4e7', boxShadow: 'inset 0 1px 0 #e4e4e7' }}>
                      <Table borderless size="sm" className="mb-0" style={{ backgroundColor: 'transparent' }}>
                        <thead>
                          <tr>
                            <th style={{ width: '40px' }}></th>
                            <th className="field-label">歌曲名稱</th>
                            <th className="field-label">數量</th>
                            <th className="field-label">金額</th>
                          </tr>
                        </thead>
                        <tbody>
                          {order.items.map(item => (
                            <tr key={item.item_id}>
                              <td></td>
                              <td>
                                <Link to={`/product/${item.item_id}`}>
                                  {TruncateWords(item.item_name, 50)}
                                </Link>
                              </td>
                              <td>{item.count}</td>
                              <td>{item.amount}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </td>
                  </tr>
                )}
                </React.Fragment>
                );
              })}
              </tbody>
            )}
          </Table>
          <Pagination>
            <Pagination.First onClick={() => paginate(1)} disabled={currentPage === 1} />
            <Pagination.Prev onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} />
            {currentPage > 2 && <Pagination.Item onClick={() => paginate(currentPage - 2)}>{currentPage - 2}</Pagination.Item>}
            {currentPage > 1 && <Pagination.Item onClick={() => paginate(currentPage - 1)}>{currentPage - 1}</Pagination.Item>}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && <Pagination.Item onClick={() => paginate(currentPage + 1)} >{currentPage + 1}</Pagination.Item>}
            {currentPage < totalPages - 1 && <Pagination.Item onClick={() => paginate(currentPage + 2)}>{currentPage + 2}</Pagination.Item>}
            <Pagination.Next onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} />
            <Pagination.Last onClick={() => paginate(totalPages)} disabled={currentPage === totalPages} />
          </Pagination>
        </>
      )}

      <Modal show={buyerInfo !== null} onHide={() => setBuyerInfo(null)} centered aria-labelledby="buyer-info-title">
        <Modal.Header closeButton>
          <Modal.Title id="buyer-info-title" as="h5">買家資訊</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {buyerInfo && (
            <div className="d-flex flex-column gap-3">
              <div>
                <div className="field-label">買家名稱</div>
                <div>{buyerInfo.costumer_name}</div>
              </div>
              <div>
                <div className="field-label">Email</div>
                {buyerInfo.costumer_email ? (
                  <a href={`mailto:${buyerInfo.costumer_email}`} style={{ wordBreak: 'break-all' }}>
                    {buyerInfo.costumer_email}
                  </a>
                ) : (
                  <div className="text-secondary">無資料</div>
                )}
              </div>
              <div>
                <div className="field-label">電話</div>
                {buyerInfo.costumer_phone ? (
                  <a href={`tel:${buyerInfo.costumer_phone}`} style={{ wordBreak: 'break-all' }}>
                    {buyerInfo.costumer_phone}
                  </a>
                ) : (
                  <div className="text-secondary">無資料</div>
                )}
              </div>
              <div>
                <div className="field-label">訂單編號</div>
                <div>{"TW" + buyerInfo.order_id.toString().padStart(6, '0')}</div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" size="sm" onClick={() => setBuyerInfo(null)}>關閉</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}
const mapStateToProps = (state) => {
  return {
    user: state.user.user,
  };
};
export default connect(mapStateToProps)(CreatorOrder);